'use client';

import { useSyncExternalStore } from 'react';

const DAYS = [
  { index: 1, name: 'Lunes' },
  { index: 2, name: 'Martes' },
  { index: 3, name: 'Miércoles' },
  { index: 4, name: 'Jueves' },
  { index: 5, name: 'Viernes' },
  { index: 6, name: 'Sábado' },
  { index: 0, name: 'Domingo' }
];

const toMinutes = (time) => {
  const [h, m] = String(time || '').split(':').map(Number);
  return Number.isFinite(h) ? h * 60 + (Number.isFinite(m) ? m : 0) : null;
};
const label = (time) => {
  const [h, m] = String(time).split(':');
  return m && m !== '00' ? `${Number(h)}:${m}` : `${Number(h)}`;
};

const subscribeNothing = () => () => {};
// Día de la semana en Argentina, recién en el navegador (el HTML se cachea una hora).
const todayIndex = () =>
  ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'].indexOf(
    new Date().toLocaleDateString('en-US', { weekday: 'short', timeZone: 'America/Argentina/Buenos_Aires' })
  );

/** Horarios de la semana dibujados como barras sobre la jornada, con el día de hoy marcado. */
export default function WeekHours({ workingHours }) {
  const today = useSyncExternalStore(subscribeNothing, todayIndex, () => null);
  const byDay = new Map();
  for (const wh of workingHours || []) {
    const ranges = (wh.working_hours || [])
      .map((r) => ({ start: r.start_time, end: r.end_time, from: toMinutes(r.start_time), to: toMinutes(r.end_time) }))
      .filter((r) => r.from !== null && r.to !== null && r.to > r.from);
    if (ranges.length) byDay.set(wh.day, [...(byDay.get(wh.day) || []), ...ranges]);
  }
  if (!byDay.size) return null;

  const all = [...byDay.values()].flat();
  const dayStart = Math.min(8 * 60, ...all.map((r) => Math.floor(r.from / 60) * 60));
  const dayEnd = Math.max(21 * 60, ...all.map((r) => Math.ceil(r.to / 60) * 60));
  const span = dayEnd - dayStart;
  const pct = (minutes) => `${((minutes - dayStart) / span) * 100}%`;
  const ticks = [];
  for (let m = dayStart; m <= dayEnd; m += 240) ticks.push(m);

  return (
    <section className="pf-sec" aria-labelledby="horarios">
      <h2 id="horarios" className="pf-h2 font-display">
        Horarios
      </h2>
      <div className="hours">
        <div className="hours__row hours__row--ticks" aria-hidden="true">
          <span />
          <span className="hours__track hours__track--ticks">
            {ticks.map((m, i) => (
              <span key={m} style={{ left: pct(m) }}>
                {m / 60}
                {i === ticks.length - 1 ? ' h' : ''}
              </span>
            ))}
          </span>
          <span />
        </div>
        {DAYS.map((day) => {
          const ranges = (byDay.get(day.index) || []).sort((a, b) => a.from - b.from);
          const isToday = today === day.index;
          return (
            <div key={day.index} className={`hours__row ${isToday ? 'is-today' : ''}`}>
              <span className="hours__day">
                {day.name}
                {isToday ? ' · hoy' : ''}
              </span>
              <span className="hours__track">
                {ranges.map((r, i) => (
                  <span key={i} className="hours__bar" style={{ left: pct(r.from), width: pct(dayStart + (r.to - r.from)) }} />
                ))}
              </span>
              <span className={`hours__text ${ranges.length ? '' : 'is-closed'}`}>
                {ranges.length ? ranges.map((r) => `${label(r.start)} a ${label(r.end)}`).join(' · ') : 'Cerrado'}
              </span>
            </div>
          );
        })}
      </div>
    </section>
  );
}
